import { Loader, ProfileEditForm } from '../../../components';
import { useUserProfileDetailsForm } from './hooks';

import type { FC } from 'react';
import type { UserProfileDetailsFormWidgetProps } from './UserProfileDetailsForm.types';

const UserProfileDetailsFormWidget: FC<UserProfileDetailsFormWidgetProps> = ({
  widget,
}) => {
  const wData = widget.data!;
  const {
    user,
    isLoading,
    onSubmit,
    countries,
    hasLoadError,
    isUserLoading,
    applyReferrerCode,
    isCountriesLoading,
    isApplyingReferrerCode,
    hasApplyReferrerCodeError,
    isApplyingReferrerCodeSuccess,
  } = useUserProfileDetailsForm(widget);

  if (
    isCountriesLoading ||
    hasLoadError ||
    isUserLoading ||
    isApplyingReferrerCode
  ) {
    return <Loader />;
  }

  return (
    <ProfileEditForm
      user={user!}
      data={wData}
      onSubmit={onSubmit}
      countries={countries!}
      config={widget.config}
      isSubmitting={isLoading}
      defaultCountry={wData.defaultCountry}
      onApplyReferrerCode={applyReferrerCode}
      hasApplyReferrerCodeError={hasApplyReferrerCodeError}
      isApplyingReferrerCodeSuccess={isApplyingReferrerCodeSuccess}
    />
  );
};

UserProfileDetailsFormWidget.displayName = 'UserProfileDetailsFormWidget';

export { UserProfileDetailsFormWidget };
